<template>
  <v-app class="website">
    <WebsiteHeader />
    <slot class="nuxt" />
    <WebsiteFooter />
  </v-app>
</template>

<style lang="stylus" scoped>
.website
  max-width 1200px
  // padding-top 50px
  margin auto
  background-color var(--white, #FFFFFF)
.nuxt
  margin-top 60px
</style>
